import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as ScenarioActions from 'app/actions/scenarios/scenarioAction.ts';
import * as ScenarioSelectors from 'app/selectors/scenarioSelectors.ts';
import { CurrentUserSelector } from 'app/selectors/userSelectors.ts';

/**
 * Loads the scenario list into Redux once per signed-in user, when it is empty.
 *
 * An organisation with no scenarios gets an empty list back, so "the list is empty" alone is not
 * enough: each response stores a new empty array, and the request would start again for ever.
 */
export const useLoadScenariosOnce = (): void => {
  const dispatch = useDispatch();
  const currentUser = useSelector(CurrentUserSelector);
  const scenarios = useSelector(ScenarioSelectors.scenariosSelector);
  const requestedForUser = useRef<number | null>(null);

  useEffect(() => {
    if (currentUser && scenarios.length === 0 && requestedForUser.current !== currentUser.id) {
      requestedForUser.current = currentUser.id;
      dispatch(ScenarioActions.getScenarios());
    }
  }, [dispatch, currentUser, scenarios]);
};
